module.exports = __webpack_public_path__ + "static/img/team-build-01.03432bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-01.png
// module id = v9DI
// module chunks = 1